import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import PropTypes from 'prop-types';
import s from './JobsSection.css';
import Button from '../../../common/components/Button/Button';

export default function JobsSectionPresentation({ isMobile, teams, jobsCount, citiesCount }) {
  useStyles(s);
  return (
    <section>
      <h2>فرصت‌های شغلی</h2>
      <div>
        <p className={s.description}>
          <span className={s.badge}>{jobsCount}</span>
          فرصت شغلی{' '}
          {citiesCount > 1 && (
            <>
              در
              <span className={s.badge}>{citiesCount} شهر</span>
              ایران
            </>
          )}
        </p>
        <div className={s.jobsGridContainer}>
          {teams
            ? teams.map((team) => (
                <div>
                  <a href={`/jobs?teamId=${team.id}`}>{team.title}</a>
                </div>
              ))
            : ''}
          {teams && teams.length % 3 !== 0 ? [...Array(3 - (teams.length % 3))].map(() => <div />) : ''}
        </div>
        <div className={s.linksWrapper}>
          <a href="/jobs">
            <Button theme="no-theme" fullWidth={isMobile}>
              همه فرصت‌های شغلی
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
}

JobsSectionPresentation.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  teams: PropTypes.array.isRequired,
  jobsCount: PropTypes.number.isRequired,
  citiesCount: PropTypes.number.isRequired,
};
